// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_93444fe79c--wrapper--xTK8c","tooltip":"_93444fe79c--tooltip--xsNkq","item":"_93444fe79c--item--VYHLT"};